<template>
	<div>
		<h1>{{$t('import')}}</h1>
		<template v-if="loaded">
			<div class="form-group">
				<label>{{ $t('import-events-from') }}</label>
				<input
					type="text"
					class="form-control"
					v-model="import_name"
					@focus="selectTimetable"
				>
			</div>
			<div class="form-group">
				<label>{{ $t('tt-copy-method') }}</label>
				<select
					class="form-control"
					v-model="import_method"
				>
					<option value="template">{{ $t('tt-copy-template') }}</option>
					<option value="all">{{ $t('tt-copy-all') }}</option>
				</select>
			</div>
			<div class="form-group">
				<button class="btn btn-primary" @click="importTimetable">{{$t('import')}}</button>
			</div>
		</template>
		<template v-else>
			<div>
				<div class="skeleton midnight h32 w200 mr-4 mb-3"></div>
				<div class="skeleton midnight h32 mr-4 mb-3"></div>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	components: {
	},
	data() {
		return {
			error: null,
			loaded: false,
			import_id: null,
			import_name: null,
			import_method: 'template',
			timetable: null,
			timetables: []
		}
	},
	mounted() {
		if (!this.$route.params["timetableid"]) {
			this.error = this.$t("failed-load-timetable");
		} else {
			this.loadTimetable();
		}
	},
	methods: {
		loadTimetable: function () {
			this.$cfetch(`${this.$settings.APIBaseURL}/timetable/tttimetable/get`, {
				data: {
					tttimetable_id: Number(this.$route.params["timetableid"])
				},
			}).then((res) => {
				if (res.status === "SUCCESS") {
					this.timetable = res.result;
					this.getTimetables();
					this.loaded = true;
				} else {
					if (res.error_message) {
						this.error = res.error_message;
					} else {
						this.error = this.$t("failed-load-timetable");
					}
				}
			});
		},
		importTimetable: function(){
			this.$store.commit("showBlockingSpinner");
			this.$cfetch(`${this.$settings.APIBaseURL}/timetable/tttimetable/import`, {
				data: {
					dest_tttimetable_id: Number(this.$route.params["timetableid"]) ,
					source_tttimetable_id: this.import_id ,
					import_method: this.import_method
				},
			}).then((res) => {
				this.$store.commit("hideBlockingSpinner");
				if (res.status === "SUCCESS") {
					this.$router.push(`/timetables/edit/${this.$route.params["timetableid"]}`);
				} else {
					if (res.error_message) {
						this.error = res.error_message;
					} else {
						this.error = this.$t("failed-load-timetable");
					}
				}
			});

		},
		getTimetables: function(){

			this.$cfetch(
				`${this.$settings.APIBaseURL}/timetable/tttimetable/list`, {
					data: {
						filters: {
							'`tttimetable`.`tttimetable_id`': {
								method: 'not in' ,
								value: [
									this.$route.params['timetableid']
								]
							}
						},
						limit: 500
					},
					method: 'post'
				}
			).then((json) => {
				if (json.status === "SUCCESS") {
					this.timetables = json.results;
					this.loaded = true;
				}
			});
		},
		selectTimetable: function(){

			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t("import-events-from"),
				selectCallback: function(selection) {
					self.import_name = selection.name;
					self.import_id = selection.id
					self.$store.commit("closeModal");
				},
				selected: [
					{
						id: this.import_id
					}
				],
				data: this.timetables,
				captionKey: "name"
			});
		}

	},
	computed: {
	}
};
</script>
